import React from 'react'
import MiniatureGear from 'app/gears/home/components/MiniatureGear'
import LgyLink from 'app/components/util/lgy-link/LgyLink'

/**
 * The part of the Admin Gear that displays in the Gearbox. Right now it's just a "dumb" list of links.
 * 
 * TODO: perhaps display flags for notable events, like help tickets or failed batch jobs
 */
const AdminMiniGear = () =>
  <MiniatureGear name='Admin Gear' doubleWide doubleTall link='/lgyhub/admin'>
    <h4>Admin Gear</h4>
    <ul className='mini-gear-list usa-sidenav-list usa-sidenav-sub_list'>
      <li><LgyLink to='/lgyhub/admin/announcements'>Announcements</LgyLink></li>
      <li><LgyLink to='/lgyhub/admin/jobs'>Jobs</LgyLink></li>
      <li><LgyLink to='/lgyhub/admin/users'>Users</LgyLink></li>
      <li><LgyLink to='/lgyhub/admin/help-tickets'>Help Tickets</LgyLink></li>
      <li><LgyLink to='/lgyhub/admin/enterprise-settings'>Enterprise Settings</LgyLink></li>
    </ul>
  </MiniatureGear>

export default AdminMiniGear